/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * Copyright IBM Corp. 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../nls/StringResources'
], (StringResources) => {
	return (items) => {
		const data = [];
		const explore = [];
		const present = [];
		const other = [];
		items.forEach(item => {
			if ( item.assetClass ) {
				switch ( item.assetClass ) {
					case 'data': return data.push(item);
					case 'explore': return explore.push(item);
					case 'present': return present.push(item);
					default: return other.push(item);
				}
			} else {
				// TODO: Clean this up as asset types declare their assetClass property...
				switch ( item.id ) {
					case 'com.ibm.bi.ca-uploadModeller.ca-modeller-glass-upload':
					case 'com.ibm.bi.ca-modeller.ca-modeller':
						return data.push(item);
					case 'com.ibm.bi.explore.createDashboard':
					case 'com.ibm.bi.notebook.createNotebook':
						return explore.push(item);
					case 'com.ibm.bi.dashboard.createDashboard':
					case 'com.ibm.bi.authoring.createTemplate':
					case 'com.ibm.bi.story.createStory':
						return present.push(item);
					default: return other.push(item);
				}
			}
		});
		return [{
			label: StringResources.get('createMenu_data'),
			className: 'data',
			items: data
		}, {
			label: StringResources.get('createMenu_explore'),
			className: 'explore',
			items: explore
		}, {
			label: StringResources.get('createMenu_present'),
			className: 'present',
			items: present
		}, {
			label: StringResources.get('createMenu_other'),
			className: 'other',
			items: other
		}].filter(group => group.items.length > 0);
	};
});